/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ valueText: NonNullable<unknown> }} Exercise_Personal_Strength_E1rmInputs */

const en_us2_exercise_personal_strength_e1rm = /** @type {(inputs: Exercise_Personal_Strength_E1rmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your estimated max strength: ${i?.valueText}`)
};

const pt_br2_exercise_personal_strength_e1rm = /** @type {(inputs: Exercise_Personal_Strength_E1rmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sua força máxima estimada: ${i?.valueText}`)
};

const es_419_exercise_personal_strength_e1rm = /** @type {(inputs: Exercise_Personal_Strength_E1rmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu fuerza máxima estimada: ${i?.valueText}`)
};

const pt_pt2_exercise_personal_strength_e1rm = /** @type {(inputs: Exercise_Personal_Strength_E1rmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A tua força máxima estimada: ${i?.valueText}`)
};

const fr_fr2_exercise_personal_strength_e1rm = /** @type {(inputs: Exercise_Personal_Strength_E1rmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ta force max estimée : ${i?.valueText}`)
};

const de_de2_exercise_personal_strength_e1rm = /** @type {(inputs: Exercise_Personal_Strength_E1rmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Deine geschätzte Maximalkraft: ${i?.valueText}`)
};

const it_it2_exercise_personal_strength_e1rm = /** @type {(inputs: Exercise_Personal_Strength_E1rmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La tua forza massima stimata: ${i?.valueText}`)
};

/**
* | output |
* | --- |
* | "Your estimated max strength: {valueText}" |
*
* @param {Exercise_Personal_Strength_E1rmInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_strength_e1rm = /** @type {((inputs: Exercise_Personal_Strength_E1rmInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Strength_E1rmInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_strength_e1rm(inputs)
	if (locale === "es-419") return es_419_exercise_personal_strength_e1rm(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_strength_e1rm(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_strength_e1rm(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_strength_e1rm(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_strength_e1rm(inputs)
	return en_us2_exercise_personal_strength_e1rm(inputs)
});
export { exercise_personal_strength_e1rm as "exercise-personal.strength_e1rm" }